import { render, staticRenderFns } from "./newUserIcon.vue?vue&type=template&id=46260ea9"
import script from "./newUserIcon.vue?vue&type=script&lang=js"
export * from "./newUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports